import makeStyles from "@material-ui/core/styles/makeStyles";

import logoLong from "common/assets/logo-long.png";
import loginStyles from "features/login-screen/login.styles";

const useStyles = makeStyles(loginStyles);

function Header() {
  const classes = useStyles();

  return (
    <header className={classes.header}>
      <img src={logoLong} alt="FYIsoft logo" className={classes.logo} />
    </header>
  );
}

export default Header;
